// extracted by mini-css-extract-plugin
module.exports = {"priceItemList":"PriceItemList_priceItemList__2092-","priceListItem":"PriceItemList_priceListItem__3DDsM"};